import type { AIAgent } from '@features/ai-agents/services/agents-api';
import { agentKbases } from '@features/ai-agents/utils/labels';

/** "1 Agent" / "3 Agents": how many agents answer from a base. */
export function agentsLabel(count: number) {
  return count === 1 ? '1 Agent' : `${count} Agents`;
}

/** Agents whose only linked knowledge base is this one. */
export function agentsSolelyUsingKbase(
  agents: AIAgent[],
  kbaseId: number
): AIAgent[] {
  return agents.filter((agent) => {
    const kbases = agentKbases(agent);
    return kbases.length === 1 && kbases[0].id === kbaseId;
  });
}

/** "levntura.com/home" for https://www.levntura.com/home/ */
export function displayUrl(url: string) {
  return url
    .replace(/^https?:\/\//i, '')
    .replace(/^www\./i, '')
    .replace(/\/$/, '');
}
